import { Component, Inject } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { MessageService } from "primeng/api";
import { InvestorService } from "src/services/investor.service";

@Component({
  selector: "app-update-pan-modal",
  templateUrl: "./update-pan-modal.component.html",
  styleUrls: ["./update-pan-modal.component.scss"],
})
export class UpdatePanModalComponent {
  panForm: FormGroup;
  isLoading = false;

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<UpdatePanModalComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: { userId: number; currentPan: string },
    private investorService: InvestorService,
    private messageService: MessageService
  ) {
    this.panForm = this.fb.group({
      pan: [
        data.currentPan,
        [Validators.required, Validators.pattern("[A-Z]{5}[0-9]{4}[A-Z]{1}")],
      ],
    });
  }

  onSubmit() {
    if (this.panForm.invalid) {
      return;
    }

    this.isLoading = true;
    const body = {
      user_id: this.data.userId,
      pan: this.panForm.value.pan,
    };

    this.investorService.updatePanNumber(body).subscribe({
      next: (response) => {
        this.isLoading = false;
        this.messageService.add({
          severity: "success",
          summary: "Success",
          detail: response.message || "PAN number updated successfully",
        });
        this.dialogRef.close(true);
      },
      error: (error) => {
        this.isLoading = false;
        this.messageService.add({
          severity: "error",
          summary: "Error",
          detail: error.error?.message || "Failed to update PAN number",
        });
      },
    });
  }

  onCancel() {
    this.dialogRef.close(false);
  }
}
